import { render, staticRenderFns } from "./WhiteSheet.vue?vue&type=template&id=1066a2b4&scoped=true"
import script from "./WhiteSheet.vue?vue&type=script&lang=js"
export * from "./WhiteSheet.vue?vue&type=script&lang=js"
import style0 from "./WhiteSheet.vue?vue&type=style&index=0&id=1066a2b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1066a2b4",
  null
  
)

export default component.exports